import React, { FC } from 'react';
import { WebpagePreview } from 'components/WebpagePreview/WebpagePreview';
import { useAppStore } from 'stores/appStore';

export const StoreSetupStepPreview: FC = () => {
  const storeName = useAppStore((state) => state.storeName);

  return <WebpagePreview skeletonEnabled headerTitle={storeName} />;
};
